import classNames from 'classnames';
import styles from './product-benefits.module.scss';
import { FC } from 'react';
import { AvailabilityItem, Benefit } from '.';

export type ProductBenefitsProps = {
  deliveryText: string;
  availabilityText: string;
  isDeliverable: boolean;
  availableProducts: number;
  benefits?: string[];
};

export const ProductBenefits: FC<ProductBenefitsProps> = ({
  deliveryText,
  availabilityText,
  isDeliverable,
  availableProducts,
  benefits = [],
}) => {
  return (
    <div className={classNames(styles.productBenefits, styles.defaultContentType)}>
      <div className={styles.benefitsWrapper}>
        <div className={styles.availabilityInfo}>
          <div className={styles.availabilityWrapper}>
            {isDeliverable && (
              <AvailabilityItem itemText={deliveryText} icon='zustellung' />
            )}
            {0 < availableProducts && (
              <AvailabilityItem itemText={availabilityText} icon='Verfugbarkeit' />
            )}
          </div>
        </div>

        <div className={styles.benefits}>
          {benefits.map((benefit) => (
            <Benefit key={benefit} text={benefit} />
          ))}
        </div>
      </div>
    </div>
  );
};
